import React, { useState, useEffect } from "react"
import { Grid, Typography, TextField, Button, makeStyles, createStyles, Theme, Slider, withStyles, Box } from "@material-ui/core"
import BackgroundImage from '../../resources/images/background.jpg'
import { SketchPicker, ChromePicker } from "react-color"
import NailImage from './resources/images/nail.png'
import ColorSlider from "./components/ColorSlider"
import OrderManager from "../../OrderManager/OrderManager"
import { OrderPacket } from "../../OrderManager/OrderManager"
import { max } from "rxjs/operators"

const orderManager = new OrderManager("ws://192.168.4.1:81");

const useStyles = makeStyles((theme: Theme) => createStyles({
    container: {
        minHeight: "100vh",
        backgroundImage: `url(${BackgroundImage})`,
        backgroundSize: "cover"
    },
    mixerPicker: {
        minHeight: "40vh",
        background: "white",
        backgroundSize: "cover"
    }
}));

const Mixer: React.FC = () => {
    const styles = useStyles();
    const [r, setR] = useState<number>(0);
    const [g, setG] = useState<number>(0);
    const [b, setB] = useState<number>(0);
    const [connected, setConnected] = useState<boolean>(orderManager.is_connected());

    useEffect(() => {
        setInterval(() => setConnected(orderManager.is_connected()), 500)
    });

    return (
        <Grid container className={styles.container} direction="column" justify="center" alignItems="center">
            <Grid item className={styles.mixerPicker} xs={5}>
                <Grid container justify="center" spacing={5}>
                    <Grid style={{ marginTop: "1em" }} item>
                        <Typography variant="h4">
                            Chroma-Nail
                        </Typography>
                        {connected ? <p>Connected</p> : <p>Disconnected</p>}
                    </Grid>
                    <Grid container justify="space-evenly" direction="row">
                        <Grid item>
                            <ColorSlider onChange={(e: any, val: any) => setR(val)} valueLabelDisplay="auto" max={255} defaultValue={0} sliderColor="red" orientation="vertical" />
                        </Grid>
                        <Grid item>
                            <ColorSlider onChange={(e: any, val: any) => setG(val)} valueLabelDisplay="auto" max={255} defaultValue={0} sliderColor="green" orientation="vertical" />
                        </Grid>
                        <Grid item>
                            <ColorSlider onChange={(e: any, val: any) => setB(val)} valueLabelDisplay="auto" max={255} defaultValue={0} sliderColor="blue" orientation="vertical" />
                        </Grid>
                    </Grid>
                    <Grid style={{ paddingTop: "2em" }} container justify="space-evenly" direction="row">
                        <Grid item>
                            <svg width="200" height="200">
                                <circle cx="100" cy="100" r="100" fill={"rgb(" + r + "," + g + "," + b + ")"} />
                            </svg>
                        </Grid>
                    </Grid>
                    <Grid style={{ paddingBottom: "2em" }} item>
                        <Button onClick={() => {
                            // So we want to output 3mL or 3 x 1400 steps
                            // Sum the vals
                            // Take percentage of 3mL
                            const sum = r + g + b;
                            if (sum > 0) {
                                const STEPS = 10 * 1400;
                                const kval = 1 - Math.max(r / 255, g / 255, b / 255);
                                const cval = (1 - (r / 255) - kval) / (1 - kval);
                                const mval = (1 - (g / 255) - kval) / (1 - kval);
                                const yval = (1 - (b / 255) - kval) / (1 - kval);
                                const sumvals = kval + cval + mval + yval;
                                // const quantities = [(kval / sumvals) * STEPS / 2, (cval / sumvals) * STEPS, (mval / sumvals) * STEPS, (yval / sumvals) * STEPS];


                                const quantities = [5000, 5000];
                                console.log(quantities)

                                const packet: OrderPacket = { type: "sequential_pump", delay: 3000, pumpIds: [2, 3], quantities: quantities }
                                orderManager.sendOrder(packet);
                            }
                        }}>
                            Submit Order
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}

export default Mixer;